import { StyleSheet } from 'react-native';

import AlertStraightTriangleIcon from '@/assets/icons/alertTriangleWhite';
import { ds } from '@/components/lib/design.system';
import { Banner } from '@/feature/betslip-sbk/components/Banner';

export const WarningBanner = ({ message }: { message: string }) => (
    <Banner
        textColor={ds.colorToken.text.primary}
        leftIcon={<AlertStraightTriangleIcon />}
        message={message}
        style={styles.banner}
    />
);

const styles = StyleSheet.create({
    banner: {
        borderColor: ds.colorValue.border.subtle,
        borderWidth: 1,
    },
});
